import request from "./http";
import qs from 'qs'

//能流图->获取单位能流图列表及树节点信息
// 
export function findUnitInfo(params) {
    return request({
        url: "/diagram/unitInfo",
        method: "get",
        params
 
    });
}
//能流图->保存-修改能流图信息
// 
export function diagramSave(params) {
    return request({
        url: "/diagram/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
//能流图->根据id删除能流图信息
// 
export function diagramDelete(params) {
    return request({
        url: "/diagram/delete",
        method: "delete",
        params
    });
}
//能流图->保存-修改能流图(节点)信息
// 
export function diagramNodeSave(params) {
    return request({
        url: "/diagram/node/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
//能流图->根据节点id删除节点信息
// 
export function diagramNodeDelete(params) {
    return request({
        url: "/diagram/node/delete",
        method: "delete",
        params
    });
}
//能流图->根据节点id获取绑定设备列表
// 
export function getDeviceByNodeId(params) {
    return request({
        url: "/diagram/node/getDeviceByNodeId",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}
//能流图->添加能流图节点的关联设备
// 
export function diagramDeviceSave(params) {
    return request({
        url: "/diagram/device/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
//能流图->移除能流图节点的关联设备
// 
export function diagramDeviceDelete(id) {
    return request({
        url: "/diagram/device/delete",
        method: "delete",
        params:{
            "ids":id
        }
    });
}

// 	 * 能流图->获取损耗级别对应颜色提示
//  checked 是否选中:0-是,1-否
//  wasteType  损耗类型：0-能流图,1-线损,2-变损

export function diagramHintFind(params) {
    return request({
        url: "/diagram/hint/find",
        method: "get",
        params
    });
}
// 	 * 能流图->修改损耗级别对应颜色提示


export function diagramHintSave(params) {
    return request({
        url: "/diagram/hint/save",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params
    });
}
//首页获取建筑信息
// 
export function findEnergyBuildingInfoById(params) {
    return request({
        url: "/building/findEnergyBuildingInfoById",
        method: "get",
        params
    });
}
//建筑信息页获取建筑类型
// 
export function findAllBuildingType() {
    return request({
        url: "/energyBuilding/findAllBuildingType.do",
        method: "get",
    });
}
//新增建筑信息
export function saveEnergyBuildingInfo(params) {
    return request({
        url: "/building/saveEnergyBuildingInfo",
        method: "post",
        headers:{
            'Content-Type':'application/json',
            'Accept':'*/*'
          },
        data:params

    });
}
//获取建筑信息页列表
// 
export function findBuildingByNameAndNo(params) {
    return request({
        url: "/building/findBuildingByNameAndNo",
        method: "get",
        params
    });
}
//删除建筑信息页列表
// 
export function deleteEnergyBuildingInfoById(params) {
    return request({
        url: "/building/deleteEnergyBuildingInfoById",
        method: "delete",
        params
    });
}


//建筑类型列表查询
// 参数  有参数就是搜索查询  无参数就是默认全部
export function GetEnergyBuildingType(params) {
    return request({
        url: "/energyBuilding/findBuildingTypePage.do",
        method: "get",
        params,
    });
}

//新增建筑类型
// export function saveBuildingType(params) {
//     return request({
//         url: "/energyBuilding/saveBuildingType.do",
//         method: "post",
//         headers:{
//             'Content-Type':'application/x-www-form-urlencoded',
//             'Accept':'*/*'
//           },
//         data:qs.stringify(params)

//     });
// }
export function saveBuildingType(data) {
    return request({
        url: "/energyBuilding/saveBuildingType.do",
        method: "post",
        data
    });
}

//删除
// 参数  typeIds
export function deleteBuildingTypeByIds(params) {
    return request({
        url: "/energyBuilding/deleteBuildingTypeByIds.do",
        method: "delete",
        params,
    });
}

// 参数 unitId 
//获取单位下抄表设备列表
export function getMeterReadingConfigListByUnitId(data) {
    return request({
      url: "/meterReading/getMeterReadingConfigListByUnitId.do",
      method: "post",
      headers:{
        'Content-Type':'application/x-www-form-urlencoded',
        'Accept':'*/*'
       },
      data,
    });
  }
  

  //能流图展示接口
export function getEnergyFlowChart(params) {
    return request({
        url: "/energyFlow/getEnergyFlowDiagram.do",
        // url: "/energy/getEnergyFlowChart.do",
        
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
           },
        params
    });
}

// 	 *能流图综览->根据能流图Id、开始时间、结束时间、显示类型获取设备能耗信息
export function getEnergyFlowDiagram(params) {
    return request({
        url: "/diagram/getEnergyFlowDiagram",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
    });
}
